module.exports = __webpack_public_path__ + "static/media/2DGACM10.c4abbf60.jpg";